import { render, staticRenderFns } from "./rowLessons.vue?vue&type=template&id=b20f4bde&scoped=true&lang=pug&"
import script from "./rowLessons.vue?vue&type=script&lang=js&"
export * from "./rowLessons.vue?vue&type=script&lang=js&"
import style0 from "./rowLessons.vue?vue&type=style&index=0&id=b20f4bde&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f4bde",
  null
  
)

export default component.exports